
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_12052_3201)","fill":"#0E0E2C"}},[_c('path',{attrs:{"d":"M3.251 5.394L1.11 7.536A3.762 3.762 0 000 10.214c0 1.011.394 1.962 1.11 2.677a3.775 3.775 0 002.677 1.107c.97 0 1.94-.369 2.677-1.107l2.143-2.142a.757.757 0 10-1.071-1.071L5.393 11.82a2.275 2.275 0 01-3.213 0c-.429-.429-.665-1-.665-1.607a2.257 2.257 0 01.665-1.606l2.142-2.142a.757.757 0 10-1.07-1.071zM11.82 5.394L9.678 7.536a.757.757 0 101.07 1.07l2.143-2.141A3.762 3.762 0 0014 3.787a3.762 3.762 0 00-1.11-2.678 3.791 3.791 0 00-5.355 0L5.393 3.252a.757.757 0 101.071 1.07L8.606 2.18a2.275 2.275 0 013.214 0c.429.43.665 1 .665 1.607s-.236 1.177-.665 1.607z"}}),_c('path',{attrs:{"d":"M4.322 9.678a.755.755 0 001.071 0l4.285-4.285a.757.757 0 10-1.071-1.07L4.322 8.606a.757.757 0 000 1.07zM3.787 13.998c.97 0 1.94-.37 2.677-1.107l2.143-2.143a.757.757 0 00-1.071-1.07l-2.143 2.141a2.275 2.275 0 01-3.213 0l-.025-.026-1.071 1.07.025.028a3.775 3.775 0 002.678 1.107zM12.485 3.787c0 .607-.236 1.177-.665 1.606L9.678 7.536a.757.757 0 101.07 1.072l2.143-2.142A3.762 3.762 0 0014 3.786a3.762 3.762 0 00-1.11-2.678l-.026-.026-1.071 1.072.027.025c.429.43.665 1 .665 1.607z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_12052_3201"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h14v14H0z"}})])])])
          )
        }
      }
    